import React from 'react';
import PropTypes from 'prop-types';

import styles from './TitleDialog.module.css';

export default class TitleDialog extends React.PureComponent {
    static propTypes = {
        children: PropTypes.node.isRequired,
    }

    render() {
        return (
            <h2 className={styles.base}>{this.props.children}</h2>
        )
    }
}
